var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisagree = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5723 32.445C19.5723 32.445 21.4831 31.8824 23.3521 34.486C25.2211 37.0895 26.9134 39.0004 28.3919 40.3905C29.8703 41.7806 31.1721 45.3419 31.1721 46.3834C31.1721 47.4248 33.3433 48.9451 34.5149 46.8622C35.6865 44.7794 34.6869 41.7806 33.4735 39.6094C32.26 37.4382 31.823 35.7459 32.432 32.6588C33.0411 29.5717 31.9532 25.7547 28.4384 24.9736",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1227 38.4337C33.1227 38.4337 40.2035 39.0288 42.3654 36.1788C44.5273 33.3289 41.9563 32.0038 41.9563 32.0038C41.9563 32.0038 44.4343 31.4645 44.2856 29.6188C44.1368 27.773 42.756 27.2523 42.756 27.2523C42.756 27.2523 44.3739 26.3782 44.2902 24.8672C44.2065 23.3562 40.6127 22.724 40.6127 22.724C40.6127 22.724 41.9842 21.9894 41.868 20.497C41.7517 19.0046 40.4406 18.5024 38.037 18.5164C35.6333 18.5303 34.7686 17.9771 31.8861 18.0003C29.0035 18.0236 22.6062 19.2649 20.0352 19.144",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.832 26.2666C30.832 26.2666 33.073 24.3511 31.6038 19.8135",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8036 36.0198C38.8036 36.0198 34.8518 36.7962 34.8518 34.0904C34.8518 31.8495 36.5348 31.8959 36.5348 31.8959C36.5348 31.8959 34.6426 31.7704 34.6426 29.3993C34.6426 27.27 36.5534 27.2839 36.5534 27.2839C36.5534 27.2839 34.6426 27.1212 34.6426 24.8245C34.6426 23.1833 36.5348 22.802 36.5348 22.802C36.5348 22.802 34.968 22.5556 34.9448 20.4588C34.9448 20.4588 34.9448 18.4411 36.5488 18.4411",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9574 32.0039L36.541 31.9016",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.756 27.2484L36.5586 27.2891",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6137 22.7239L36.541 22.8076",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0333 15.6953C43.7949 16.062 44.4927 16.6247 45.041 17.3717C45.5894 18.1186 45.9431 19.0116 46.053 19.8785",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 13.5369C45.1459 14.0681 46.1568 14.8834 46.9512 15.9657C47.7457 17.0479 48.2582 18.3416 48.4173 19.5976",
    stroke: "white",
    strokeWidth: 0.708274,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisagree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/disagree.9dae18db433eb729a43ba0a7fd342746.svg";